export const ServiceUrls = {
    IDP_SERVICE: "https://idp-service",
    CREATE_LEAD: "https://www.careers360.com",
    COMMON_IDP_POST: "https://www.careers360.de"
};
  